import template from './file-upload.html';

export default angular
  .module('app')
  .directive('holdingFileUpload', holdingFileUpload)
  .name;

function holdingFileUpload() {
  'ngInject';

  return {
    link,
    replace: true,
    require: 'ngModel',
    restrict: 'E',
    scope: {
      documentConfig: '=',
      hideWhenSelected: '=?',
    },
    template,
  };

  function link(scope, _element, attrs, ctrl) {
    function ctrlValueUpdated(newDoc, oldDoc) {
      if (newDoc !== oldDoc) {
        scope.model.document = newDoc;
      }
    }

    function documentConfigUpdated() {
      scope.maxFiles = scope.documentConfig.maxFiles;
      scope.maxSize = scope.documentConfig.maxSize;
      scope.maxTotalSize = scope.documentConfig.maxTotalSize;
      scope.permittedFileTypes = scope.documentConfig.extensions.join();
    }

    function documentModelUpdated(newDoc, oldDoc) {
      if (newDoc !== oldDoc) {
        if (newDoc && newDoc.length) {
          ctrl.$setViewValue(newDoc);
        } else {
          ctrl.$setViewValue([]);
        }
      }
    }

    const DEFAULT_MODEL = {
      document: []
    };

    scope.model = angular.copy(DEFAULT_MODEL);
    scope.ngModel = ctrl;
    scope.noBrowseLabel = (('noBrowseLabel' in attrs) && angular.isDefined(attrs.noBrowseLabel));
    scope.uploadPercent = 0;

    scope.$watch('documentConfig', documentConfigUpdated);
    scope.$watch('model.document', documentModelUpdated);
    scope.$watch(() => ctrl.$viewValue, ctrlValueUpdated);
  }
}



// WEBPACK FOOTER //
// ./src/holding/modules/app/directives/file-upload/file-upload.js